import AppSettings from "../../../Settings/AppSettings";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import AuthManager from "../../../Common/AuthManager";

let api_base_url = AppSettings.GMS_BACKEND_API_URL;

export const getCategoryList = async (industryId) => {
  try {
    const res = await ServiceWrapper.doGet(
      `${api_base_url}industry/${industryId}/category`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    return res.errorfound ? [] : res.data.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};
